query OrganizationsAutocomplete (
  $input: String = ""
  $value: [ID!] = []
) {
  autocomplete: autocompleteOrganizations(
    input: $input, 
    value: $value, 
  ) {
    options {
      value,
      label
    }
    value {
      value,
      label
    }
  }
}

